module.exports = __webpack_public_path__ + "img/kt.392556c6.gif";